import { CdkAccordionModule } from '@angular/cdk/accordion';
import { Component, computed, input } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { SponsorExtended } from '../../../../api/app-types/sponsor.app';
import { LvrBorderDirective } from '../../../../shared/border/border';
import { LvrPaddingDirective } from '../../../../shared/padding/padding.directive';

@Component({
	selector: 'lvr-sponsor-details-view',
	standalone: true,
	templateUrl: './sponsor-details-view.html',
	styleUrl: './sponsor-details-view.scss',
	imports: [MatIconModule, TranslocoPipe, CdkAccordionModule, MatButton, LvrBorderDirective, LvrPaddingDirective],
})
export class SponsorDetailsView {
	public readonly sponsor = input.required<SponsorExtended>();

	public readonly preferredCommunicationWay = computed(() => {
		const sponsor = this.sponsor();
		return sponsor.contactPoints.find((cp) => cp.preferredWayOfContact);
	});

	public readonly communicationWays = computed(() => {
		const preferred = this.preferredCommunicationWay()?.id;
		return this.sponsor().contactPoints.filter((cp) => cp.id !== preferred);
	});
}
